const DB_NAME = 'k2-camera-recordings';
const DB_VERSION = 1;
const SESSION_STORE = 'sessions';
const CHUNK_STORE = 'chunks';

let databasePromise;

function openDatabase() {
  if (!databasePromise) {
    databasePromise = new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = () => {
        const db = request.result;

        if (!db.objectStoreNames.contains(SESSION_STORE)) {
          db.createObjectStore(SESSION_STORE, { keyPath: 'sessionId' });
        }

        if (!db.objectStoreNames.contains(CHUNK_STORE)) {
          const chunks = db.createObjectStore(CHUNK_STORE, { keyPath: 'id' });
          chunks.createIndex('sessionId', 'sessionId', { unique: false });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  return databasePromise;
}

async function run(storeName, mode, operation) {
  const db = await openDatabase();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(storeName, mode);
    const store = transaction.objectStore(storeName);
    const request = operation(store);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    transaction.onerror = () => reject(transaction.error);
  });
}

export function saveRecordingSession(session) {
  return run(SESSION_STORE, 'readwrite', (store) => store.put(session));
}

export function getRecordingSession(sessionId) {
  return run(SESSION_STORE, 'readonly', (store) => store.get(sessionId));
}

export function listRecordingSessions() {
  return run(SESSION_STORE, 'readonly', (store) => store.getAll());
}

export async function updateRecordingSession(sessionId, changes) {
  const current = (await getRecordingSession(sessionId)) || { sessionId };
  const next = {
    ...current,
    ...changes,
    updatedAt: new Date().toISOString()
  };

  await saveRecordingSession(next);
  return next;
}

export function enqueueRecordingChunk({ sessionId, index, blob, mimeType }) {
  return run(CHUNK_STORE, 'readwrite', (store) =>
    store.put({
      id: `${sessionId}:${String(index).padStart(8, '0')}`,
      sessionId,
      index,
      blob,
      mimeType,
      createdAt: new Date().toISOString()
    })
  );
}

export async function listRecordingChunks(sessionId) {
  const chunks = await run(CHUNK_STORE, 'readonly', (store) => store.getAll());
  return chunks.filter((chunk) => chunk.sessionId === sessionId).sort((a, b) => a.index - b.index);
}

export function removeRecordingChunk(id) {
  return run(CHUNK_STORE, 'readwrite', (store) => store.delete(id));
}

export async function countPendingChunks() {
  return run(CHUNK_STORE, 'readonly', (store) => store.count());
}
